import React from 'react';
var functions = require("./functions.js");

// ClientTable component
export default class CodeComponent extends React.Component {

    constructor(props) {
        super(props);
        this.contentRef = React.createRef();
    }

    getLink(){

        if(this.props.link){
            return <button className="" onClick={() => functions.openWindow( this.props.link ) }>{this.props.linkTitle}</button>
        } else {
            return ;
        }
    }
    // render
    render() {

    return (
            
            <div >
                <h2>
                    {this.props.title}
                    &nbsp;
                    <button onClick={()=>{this.copyToClipBoard()}} >Copy Code to ClipBoard</button>
                    &nbsp;
                    {this.getLink()}
                </h2>
                code:<br />
                <code ref={this.contentRef}  >
                    {this.props.children}
                </code>
            </div>

       );
    }     

    copyToClipBoard(){
        functions.copyToClipBoard(this.contentRef.current.innerHTML.replace(/<br\s*[/]?>/gi, "\n"));        
    }
}